<mat-card>
  <mat-card-header>
    <mat-card-title>Passages</mat-card-title>
    <a mat-button [routerLink]="['/passages/create']" color="primary">Add Passage</a>
  </mat-card-header>

  <mat-card-content>
    <mat-accordion>
      <ng-template ngFor let-passage [ngForOf]="paginatedPassages()">
        <!--Passage Start -->
        <mat-expansion-panel [expanded]="false">
          <mat-expansion-panel-header>
            <mat-panel-title>{{passage.title}}</mat-panel-title>
            <button mat-button color="primary" [routerLink]="['/passages/' + passage.id + '/edit']">Edit</button>
          </mat-expansion-panel-header>

          <div class="w-50">
            <mat-card-subtitle>Content</mat-card-subtitle>
            <app-ck-editor [readonlyData]=passage.content [inline]="true" [readonly]="true"></app-ck-editor>
          </div>

        </mat-expansion-panel>
        <!--Passage End-->
      </ng-template>
    </mat-accordion>
  </mat-card-content>
  <mat-paginator [length]="length"
                 [pageSize]="pageSize"
                 [pageIndex]="pageIndex"
                 [pageSizeOptions]="pageSizeOptions"
                 [selectConfig]="{ panelClass: 'paginator-page-size-panel' }"
                 (page)="getPassagesPagination($event)">
  </mat-paginator>
</mat-card>
<ng-template #loading>
  <app-spinner></app-spinner>
</ng-template>
